module.exports = __webpack_public_path__ + "static/media/printable-flashcards.ca94d4a8.png";